import React, { Component } from "react";
import 'antd/dist/antd.css';
import { Spinner } from 'reactstrap';
import axios from '../../../utils/request';
import { Result, Button, Input, message, Radio } from 'antd';
import '../cccltd.css'
const { TextArea } = Input;

//原单位第一次决策
export class CCCCLTDOrgResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            applyId: "",
            tenantId: "",
            userId: "",
            signValue: "",
            isReady: false,
            isLoading: true,
            errorMessage: "",
            infoMsg: "",
            canSubmt: false,
            reasonShow: "none"
        }
    };
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const applyId = urlParams.get("applyId");
        const timeStamp = urlParams.get("timeStamp");
        const tenantId = urlParams.get("tenantId");
        const userId = urlParams.get("userId");
        const signValue = urlParams.get("signValue");
        if (!applyId) {
            this.setState({ errorMessage: "应聘者申请Id不存在！", isLoading: false, isReady: true });
            return;
        }
        this.setState({ applyId, timeStamp, tenantId, userId, signValue });
        this.loadPage(tenantId, userId, applyId, timeStamp, signValue);
    };
    loadPage = (tenantId, userId, applyId, timeStamp, signValue) => {
        const params = {
            tenantId,
            userId,
            applyId,
            timeStamp,
            signValue
        }
        axios
            .get("/api/CCCCLTD/GetOrgDecideResult", { params: params })
            .then(res => {
                const reqCode = res.data.code;
                const orgResInfo = res.data.data;
                let canSubmt = false;
                let infoMsg = "";
                let errorMessage = "";
                if (reqCode != "200") {
                    errorMessage = "获取详细信息失败！错误信息：" + res.data.message;
                } else {
                    canSubmt = orgResInfo["canSubmit"];
                    infoMsg = orgResInfo["infoMsg"];
                }
                this.setState({ isLoading: false, isReady: true, errorMessage, canSubmt, infoMsg });

            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" + reason.response.data.message });
            })
            .finally(
            );
    };
    agree = () => {
        const params = {
            tenantId: this.state.tenantId,
            userId: this.state.userId,
            applyId: this.state.applyId,
            timeStamp: this.state.timeStamp,
            signValue: this.state.signValue
        }
        axios
            .get("/api/CCCCLTD/OrgAgree", { params: params })
            .then(res => {
                const reqCode = res.data.code;
                const orgResInfo = res.data.data;
                let canSubmt = false;
                let infoMsg = "";
                let errorMessage = "";
                if (reqCode != "200") {          
                    errorMessage = "同意操作失败！错误信息：" + res.data.message;
                } else {
                    canSubmt = orgResInfo["canSubmit"];
                    infoMsg = orgResInfo["infoMsg"];
                }
                this.setState({ isLoading: false, isReady: true, errorMessage, canSubmt, infoMsg });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" + reason.response.data.message });
            })
            .finally(
            );
    };
    refuse = () => {
        let reason = document.getElementById("reason").innerHTML;
        let reason1 = reason.replace(/\n/g, "");
        if (reason1.length <= 0) {
            message.error('拒绝理由不能为空，请输入拒绝理由！');
            return;
        };
        const params = {
            tenantId: this.state.tenantId,
            userId: this.state.userId,
            applyId: this.state.applyId,
            timeStamp: this.state.timeStamp,
            signValue: this.state.signValue,
            reason: reason
        }
        axios
            .get("/api/CCCCLTD/OrgRefuse", { params: params })
            .then(res => {
                const reqCode = res.data.code;
                const orgResInfo = res.data.data;
                let canSubmt = false;
                let infoMsg = "";
                let errorMessage = "";
                if (reqCode != "200") {        
                    errorMessage = "拒绝操作失败！错误信息：" + res.data.message;
                } else {
                    canSubmt = orgResInfo["canSubmit"];
                    infoMsg = orgResInfo["infoMsg"];
                }
                this.setState({ isLoading: false, isReady: true, errorMessage, canSubmt, infoMsg });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" + reason.response.data.message });
            })
            .finally(
            );
    };
    submitResult = () => {
        if (this.state.reasonShow == "none") {
            this.agree();
        } else {
            this.refuse();
        }
    };
    radioOnChange = e => {
        this.setState({ "reasonShow": e.target.value });
    };
    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            } else {
                if (this.state.canSubmt) {
                    return (<Result
                        key="r1"
                        extra={[
                            <br key="b1" />,
                            <p key="p1" style={{ textAlign: "center", fontSize: "17px", marginRight: "0" }}>{this.state.infoMsg}</p>,
                            <br key="b1_1" />,
                            <p key="p1_1" style={{ textAlign: "center", fontSize: "17px", marginRight: "0" }}>
                                <Radio.Group onChange={this.radioOnChange} value={this.state.reasonShow}>
                                    <Radio value="none" style={{ fontSize: "17px"}}>同意</Radio>
                                    <Radio value="block" style={{ fontSize: "17px" }}>拒绝</Radio>
                                </Radio.Group>
                            </p >,
                            <br key="b2" style={{ display: this.state.reasonShow }} />,
                            <p key="p2" style={{ textAlign: "center", fontSize: "17px", marginRight: "0", display: this.state.reasonShow }}>
                                <TextArea id="reason" placeholder="拒绝时请输入拒绝理由" style={{ maxWidth: "610px" }} />
                            </p>,
                            <br key="b3" />,
                            <p key="p3" style={{ textAlign: "center", marginRight: "0" }}>
                                <Button type="primary" onClick={this.submitResult} style={{ marginLeft: "0" }}>提交</Button>
                            </p>
                        ]} />)
                } else {
                    return (<Result
                        status="success"
                        key="r1"
                        extra={[
                            <br key="b1" />,
                            <p key="p1" style={{ textAlign: "center", fontSize: "17px", marginRight: "0" }}>{this.state.infoMsg}</p>
                        ]}

                    />)
                }

            }
        }
        else {
            return (
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }

    }
}